import { Link } from 'react-router-dom';

export const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-presentation-line',
      title: 'التوعية',
      description: 'برامج توعوية شاملة عن أضرار التدخين وفوائد الإقلاع، مع ورش عمل تثقيفية للمجتمع',
      color: 'from-primary to-primary-600',
    },
    {
      icon: 'ri-stethoscope-line',
      title: 'الاستشارات',
      description: 'استشارات طبية متخصصة مع أطباء معتمدين في علاج الإدمان والطب النفسي',
      color: 'from-secondary to-secondary-600',
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: 'الدعم الطبي',
      description: 'علاج طبي متكامل وأدوية مساعدة على الإقلاع مع متابعة الآثار الجانبية',
      color: 'from-accent to-accent-600',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'المتابعة',
      description: 'متابعة دورية ومستمرة لضمان نجاح رحلة الإقلاع والوقاية من الانتكاسة',
      color: 'from-primary-600 to-secondary',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h3 className="text-4xl md:text-5xl font-bold text-primary mb-4">خدماتنا</h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            نقدم مجموعة متكاملة من <strong>الخدمات الطبية والتوعوية</strong> لمساعدتك على الإقلاع عن التدخين
          </p>
          <div className="w-24 h-1 bg-accent mx-auto mt-4"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 animate-slide-up cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <i className={`${service.icon} text-white text-3xl`}></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-800 mb-4">{service.title}</h4>
              <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
              <Link
                to="/services"
                className="inline-flex items-center gap-2 text-primary font-medium group-hover:gap-3 transition-all duration-300 cursor-pointer"
              >
                <span>اعرف المزيد</span>
                <i className="ri-arrow-left-line"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 bg-primary text-white px-8 py-4 rounded-lg font-medium hover:bg-primary-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <span>عرض جميع الخدمات</span>
            <i className="ri-arrow-left-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};